import React from "react";
import { useState, useEffect } from "react";
import logo from "../Assets/imgs/logo.webp";
import "../styles/Home.css";
import mobileMenuLogo from "../Assets/imgs/mobile-menu-logo.webp";
import cross from "../Assets/imgs/cross-icon.webp";
import userimage from "../Assets/imgs/user-default.webp";
import menuarrow from "../Assets/imgs/down-arrow.webp";
import mobileicon from "../Assets/imgs/humburger-icon.webp";
import { Spinner } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useLocation } from "react-router-dom";
import { getCookie } from "../utils/CommonFunction";
import GuestUnsubscribeModal from "./GuestUnsubscribeModal";
// import GuestUnSubSuccessModal from "./GuestUnSubSuccessModal";
// import GuestUnSubConfirmModal from "./GuestUnSubConfirmModal";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { recaptchaSiteKey } from "../utils/config";

type Props = {
  isSubscribe: boolean;
  handleLogout: () => void;
  handleUnSubscribe: () => void;
  loader: boolean;
  errorMsg: string;
};
type RecaptchaProps = {
  open: boolean;
  setUnsubscribePopup: React.Dispatch<React.SetStateAction<boolean>>;
  // setConfirmUnsubPopup: React.Dispatch<React.SetStateAction<boolean>>;
  // setUnsubSuccessPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

function GuestUnsubscribe(props: RecaptchaProps) {
  if (!props.open) return null;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <GuestUnsubscribeModal setUnsubscribePopup={props.setUnsubscribePopup} />
    </GoogleReCaptchaProvider>
  );
}

const Header = (props: Props) => {
  // const [downloadPopup, setdownloadPopup] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const [isDropMenu, setIsDropMenu] = useState(true);
  const [unsubscribePopup, setUnsubscribePopup] = useState(false);
  // const [unsubSuccessPopup, setUnsubSuccessPopup] = useState(false);
  // const [confirmUnsubPopup, setConfirmUnsubPopup] = useState(false);
  const data = getCookie("data");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleDropMenu = () => {
    setIsDropMenu(!isDropMenu);
  };
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 1) {
        // You can change this value to the desired scroll position
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // animation
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  //
  return (
    <>
      {unsubscribePopup && (
        <GuestUnsubscribe
          open={unsubscribePopup}
          setUnsubscribePopup={setUnsubscribePopup}
          // setConfirmUnsubPopup={setConfirmUnsubPopup}
          // setUnsubSuccessPopup={setUnsubSuccessPopup}
        />
      )}
      {/* {confirmUnsubPopup && <GuestUnSubConfirmModal setConfirmUnsubPopup={setConfirmUnsubPopup}/>}
    {unsubSuccessPopup && <GuestUnSubSuccessModal setUnsubSuccessPopup={setUnsubSuccessPopup}/> } */}
      <div>
        <div className="job-portal">
          {/* download modal */}

          <div className={`header ${isSticky ? "sticky-header" : ""}`}>
            <div className="container">
              <div className="row">
                <div className="  col-md-4 col-5">
                  <div className="header-logo">
                    <HashLink
                      to="/#"
                      scroll={(el: any) =>
                        el.scrollIntoView({
                          behavior: "smooth",
                          block: "end",
                        })
                      }
                    >
                      <img src={logo} width={125} alt="logo image" />
                    </HashLink>
                  </div>
                </div>
                <div className="col-md-8 col-7">
                  <div className="menu-item">
                    <ul className="ds-desktop">
                      <li>
                        {/* <a href="/">Home</a> */}
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <HashLink
                          to="/#featured-job"
                          smooth
                          scroll={(el: any) =>
                            el.scrollIntoView({
                              behavior: "smooth",
                              block: "end",
                            })
                          }
                        >
                          Featured Jobs
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/#howitwork"
                          smooth
                          scroll={(el: any) =>
                            el.scrollIntoView({
                              behavior: "smooth",
                              block: "end",
                            })
                          }
                        >
                          How it works
                        </HashLink>
                      </li>
                      <li>
                        <HashLink
                          to="/#category"
                          smooth
                          scroll={(el: any) =>
                            el.scrollIntoView({
                              behavior: "smooth",
                              block: "end",
                            })
                          }
                        >
                          Job Categories
                        </HashLink>
                      </li>
                    </ul>
                    {/* mobile menu */}
                    {!isMenuOpen && (
                      <div className="mobile-menu ds-mobile">
                        <div className="mb-logo">
                          <img
                            src={mobileMenuLogo}
                            width={100}
                            height={29}
                            alt="logo"
                            className="logo-res"
                          />
                          <div className="cross" onClick={toggleMenu}>
                            <img src={cross} />
                          </div>
                        </div>
                        <ul>
                          <li>
                            <HashLink
                              to="/#"
                              smooth
                              scroll={(el: any) =>
                                el.scrollIntoView({
                                  behavior: "smooth",
                                  block: "end",
                                })
                              }
                              onClick={toggleMenu}
                            >
                              Home
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              to="/#featured-job"
                              smooth
                              scroll={(el: any) =>
                                el.scrollIntoView({
                                  behavior: "smooth",
                                  block: "end",
                                })
                              }
                              onClick={toggleMenu}
                            >
                              Featured Jobs
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              to="/#howitwork"
                              smooth
                              scroll={(el: any) =>
                                el.scrollIntoView({
                                  behavior: "smooth",
                                  block: "end",
                                })
                              }
                              onClick={toggleMenu}
                            >
                              How it works
                            </HashLink>
                          </li>
                          <li>
                            <HashLink
                              to="/#category"
                              smooth
                              scroll={(el: any) =>
                                el.scrollIntoView({
                                  behavior: "smooth",
                                  block: "end",
                                })
                              }
                              onClick={toggleMenu}
                            >
                              Job Categories
                            </HashLink>
                          </li>

                          {props.isSubscribe ? (
                            <>
                              {data?.subPackage !== "postpaid" && (
                                // <li>
                                //   <Link
                                //     to="/subscriptionpage"
                                //     onClick={toggleMenu}
                                //   >
                                //     Subscription Plans
                                //   </Link>
                                // </li>
                                <></>
                              )}
                              <li>
                                <a
                                  onClick={() => {
                                    props.handleLogout();
                                  }}
                                >
                                  Logout
                                </a>
                              </li>
                              {props.loader ? (
                                <>
                                  <li>
                                    <a href="javascript:;" className="d-button">
                                      <Spinner
                                        animation="border"
                                        // className="SpinnerBtn"
                                        role="status"
                                        style={{ color: "#fff" }}
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </Spinner>
                                    </a>
                                  </li>
                                </>
                              ) : (
                                <>
                                  <li>
                                    <a
                                      href="javascript:;"
                                      className="d-button"
                                      onClick={() => {
                                        props.handleUnSubscribe();
                                      }}
                                    >
                                      Unsubscribe
                                    </a>
                                    <div
                                      style={{ color: "red", marginTop: "5px" }}
                                    >
                                      {props.errorMsg}
                                    </div>
                                  </li>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {" "}
                              <li>
                                <a
                                  href="/landingjazzcash?plan_id=7"
                                  className="d-button"
                                >
                                  Subscribe
                                </a>
                              </li>
                            </>
                          )}
                          {!props.isSubscribe && (
                            <>
                              <li>
                                <a
                                  href="javascript:;"
                                  className="d-button"
                                  onClick={() => {
                                    toggleDropMenu();
                                    setUnsubscribePopup(true);
                                  }}
                                >
                                  Unsubscribe
                                </a>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    )}

                    <div className="signup-header">
                      {props.isSubscribe ? (
                        <>
                          {" "}
                          <div className="header-menu-dropdown">
                            <div className="dropdown-menu-des">
                              <div className="image">
                                <img
                                  src={userimage}
                                  width={50}
                                  height={50}
                                  alt="user image"
                                  onClick={toggleDropMenu}
                                />
                              </div>
                              <div className="icon">
                                <img
                                  src={menuarrow}
                                  width={15}
                                  height={8}
                                  alt="down icon"
                                  onClick={toggleDropMenu}
                                />
                              </div>

                              {!isDropMenu && (
                                <div className="mobile-menu ds-mobile desk-dropdown">
                                  <div className="mb-logo">
                                    <img
                                      src={mobileMenuLogo}
                                      width={100}
                                      height={29}
                                      alt="logo"
                                      className="logo-res"
                                    />
                                    <div
                                      className="cross"
                                      onClick={toggleDropMenu}
                                    >
                                      <img src={cross} alt="cross icon" />
                                    </div>
                                  </div>
                                  <ul>
                                    {data?.subPackage !== "postpaid" && (
                                      // <li>
                                      //   <Link
                                      //     to="/subscriptionpage"
                                      //     onClick={toggleMenu}
                                      //   >
                                      //     Subscription Plans
                                      //   </Link>
                                      // </li>
                                      <> </>
                                    )}
                                    <li>
                                      <a
                                        onClick={() => {
                                          props.handleLogout();
                                        }}
                                      >
                                        Logout
                                      </a>
                                    </li>

                                    {props.loader ? (
                                      <>
                                        <li>
                                          <a
                                            href="javascript:;"
                                            className="d-button"
                                          >
                                            <Spinner
                                              animation="border"
                                              // className="SpinnerBtn"
                                              role="status"
                                              style={{ color: "#fff" }}
                                            >
                                              <span className="visually-hidden">
                                                Loading...
                                              </span>
                                            </Spinner>
                                          </a>
                                        </li>
                                      </>
                                    ) : (
                                      <>
                                        <li>
                                          <a
                                            href="javascript:;"
                                            className="d-button"
                                            onClick={() => {
                                              props.handleUnSubscribe();
                                            }}
                                          >
                                            Unsubscribe
                                          </a>
                                          <div
                                            style={{
                                              color: "red",
                                              marginTop: "5px",
                                            }}
                                          >
                                            {props.errorMsg}
                                          </div>
                                        </li>
                                      </>
                                    )}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="signup-button">
                            <a
                              href="/landingjazzcash?plan_id=7"
                              className="d-button d-button-dark"
                            >
                              Subscribe
                            </a>
                          </div>
                        </>
                      )}

                      <div className="hamburger-icon">
                        <img
                          src={mobileicon}
                          width={32}
                          height={32}
                          alt="Menu"
                          onClick={toggleMenu}
                        />
                      </div>
                    </div>

                    <div
                      className="signup-header"
                      style={{ marginLeft: "20px" }}
                    >
                      {!props.isSubscribe && (
                        <>
                          {" "}
                          <div className="header-menu-dropdown">
                            <div className="dropdown-menu-des">
                              <div className="image">
                                <img
                                  src={userimage}
                                  width={50}
                                  height={50}
                                  alt="user image"
                                  onClick={toggleDropMenu}
                                />
                              </div>
                              <div className="icon">
                                <img
                                  src={menuarrow}
                                  width={15}
                                  height={8}
                                  alt="down icon"
                                  onClick={toggleDropMenu}
                                />
                              </div>

                              {!isDropMenu && (
                                <div className="mobile-menu ds-mobile desk-dropdown">
                                  <div className="mb-logo">
                                    <img
                                      src={logo}
                                      width={100}
                                      height={29}
                                      alt="logo"
                                      className="logo-res"
                                    />
                                    <div
                                      className="cross"
                                      onClick={toggleDropMenu}
                                    >
                                      <img src={cross} alt="cross icon" />
                                    </div>
                                  </div>
                                  <ul>
                                    <li>
                                      <a
                                        href="javascript:;"
                                        className="d-button"
                                        onClick={() =>
                                          setUnsubscribePopup(true)
                                        }
                                      >
                                        Unsubscribe
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
